import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridBuilderComponent } from './grid-builder/grid-builder.component';
import { RappiderListGridModule } from '../list-grid/list-grid.module';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { GridBuilderColumnsComponent } from './grid-builder-columns/grid-builder-columns.component';
import { GridBuilderSettingsComponent } from './grid-builder-settings/grid-builder-settings.component';
import { RappiderSelectModule } from '../select/select.module';
import { RappiderTextboxModule } from '../textbox/textbox.module';
import { FormsModule } from '@angular/forms';
import { RappiderModalModule } from '../modal/modal.module';
import { RappiderSwitchModule } from '../switch/switch.module';
import { RappiderButtonModule } from '../button/button.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RappiderNumberInputModule } from '../number-input/number-input.module';
import { ActionsInputComponent } from './actions-input/actions-input.component';
import { RappiderTextareaModule } from '../textarea/textarea.module';
import { RappiderIconPickerWrapperModule } from '../icon-picker-wrapper/icon-picker-wrapper.module';
import { RappiderStringArrayModule } from '../string-array/string-array.module';
import { AngularSplitModule } from 'angular-split';
import { RappiderJsonEditorModalModule } from '../json-editor-modal/json-editor-modal.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RappiderAlertModule } from '../alert/alert.module';
import { NzFormModule } from 'ng-zorro-antd/form';
import { RappiderFieldFormattingToolbarModule } from '../field-formatting-toolbar/field-formatting-toolbar.module';

@NgModule({
  declarations: [
    GridBuilderComponent,
    GridBuilderColumnsComponent,
    GridBuilderSettingsComponent,
    ActionsInputComponent
  ],
  imports: [
    CommonModule,
    NzTabsModule,
    FormsModule,
    RappiderListGridModule,
    RappiderModalModule,
    RappiderTextboxModule,
    RappiderSelectModule,
    RappiderSwitchModule,
    RappiderButtonModule,
    DragDropModule,
    RappiderNumberInputModule,
    RappiderTextareaModule,
    RappiderIconPickerWrapperModule,
    RappiderStringArrayModule,
    AngularSplitModule,
    NzToolTipModule,
    RappiderAlertModule,
    RappiderJsonEditorModalModule,
    NzToolTipModule,
    NzFormModule,
    RappiderFieldFormattingToolbarModule
  ],
  exports: [
    GridBuilderComponent,
    ActionsInputComponent
  ]
})
export class RappiderGridBuilderModule { }
